<template>
  <main
    v-if="furniture"
    class="furniture">
    <article
      v-for="(item, key) in items"
      class="furniture__item"
      :key="`furniture${key}`">
      <router-link
        v-if="item.slideshow && item.slideshow[0]"
        :to="`/furniture/${item.slug}`"
        class="furniture__item-link link">
        <div class="link__details">
          <h4 v-html="getFurnitureName(item)"></h4>
          <div v-html="item.details"></div>
        </div>
        <img
          v-if="item.slideshow && item.slideshow[0]"
          class="link__image"
          :class="{
            'link__image--landscape': item.slideshow[0].image.width > item.slideshow[0].image.height,
            'link__image--portrait': item.slideshow[0].image.height >= item.slideshow[0].image.width
          }"
          :src="item.slideshow[0].image.url" />
        <h2 v-html="item.name"></h2>
      </router-link>
    </article>
  </main>
</template>

<script>
export default {
  name: 'Furniture',
  data() {
    return {
      furniture: null,
      items: null,
      intersectOptions: {
        root: null, // document.querySelector('.furniture'),
        rootMargin: '0px 0px 20px 0px',
        threshold: 1
      },
      intersectObserver: null
    }
  },
  async created() {
    this.furniture = await this.getFurniture()

    this.items = this.furniture.filter(item => {
      return item.slideshow && item.slideshow[0]
    })

    this.$Progress.finish()

    this.intersectObserver = new IntersectionObserver(this.handleIntersect, this.intersectOptions);

    setTimeout(() => { this.setupIntersectObserve() }, 400)
  },
  methods: {
    getFurniture() {
      return new Promise((resolve, reject) => {
        this.$http.get(`${process.env.VUE_APP_API_ADDRESS}/furniture`)
        .then(response => {
          resolve(response.body)
        })
      })
    },
    getFurnitureName(item) {
      return item.year !== '' ? `${item.name} (${item.year})` : item.name
    },
    setupIntersectObserve() {
      const furnitureItems = document.querySelectorAll('.furniture__item')

      furnitureItems.forEach(item => {
        this.intersectObserver.observe(item)
      })
    },
    handleIntersect(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('furniture__item--visible')
        }

        if (!entry.isIntersecting) {
          entry.target.classList.remove('furniture__item--visible')
        }
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$Progress.start()
    })
  }
}
</script>
<style lang="scss" scoped>
.furniture {
  @include page($margin: true);

  &__item {
    width:100%;
    font-family:$maison;
    margin: 0 0 #{$site-padding * 2} 0;
    padding: #{$site-padding * 5} 0 0 0;
    border-top: 2px solid $color;
    // padding: $site-padding 0 0 0;
    .link {
      display:flex;
      flex-direction: row;
      justify-content: flex-start;
      padding:0 0 0 0;
      margin:0 0 $site-padding-lrg 0;
      position: relative;

      &:hover {
        h2 {
          opacity: 1;
        }
      }

      &__details {
        width:calc(50% - #{$site-padding / 2});
        margin:0 $site-padding 0 0;

        h4 {
          font-size:$body;
          text-transform:uppercase;
        }
      }

      &__image {
        width:auto;
        max-width:calc(50% - #{$site-padding / 2});
        height:100%;
        // max-height: 640px;
        max-height: 640px;
        object-fit: contain;
        object-position: 0% 0%;

        &--portrait {
          height: calc((50vw - #{$site-padding * 2.5}) * 1.25);
        }

        &--landscape {
          height: calc((50vw - #{$site-padding * 2.5}) * 0.75);
        }
      }

      h2 {
        font-size: $heading;
        position: absolute;
        left: 50%;
        top: calc(-#{$heading} - #{$site-padding});
        transform: translateX(-50%);
        width: auto;
        min-width: 80%;
        text-align: center;
        text-transform: uppercase;
        opacity: 0;
        pointer-events: none;
        transition: opacity 200ms ease-in-out;
      }
    }
  }

  @include mobile {
    &__item {
      flex-wrap:wrap;
      margin: #{$site-padding * 1} 0;
      padding-top: 4rem;

      &--visible {
        .link {
          h2 {
            opacity: 1;
          }
        }
      }

      .link {
        flex-wrap:wrap;

        &__image {
          width:100% !important;
          max-height: 600px;
          max-width: unset;
          order:1;
          height:calc((100vw - 2rem) * 0.75);
          margin: 0 0 #{$site-padding / 2} 0;

          &--landscape {
            object-fit: cover;
            object-position: 50% 50%;
          }
        }

        &__details {
          width:100%;
          order:2;
          margin:0px;
          h4, p {
            font-size:$body--m !important;
            line-height:1.25;
          }
        }

        h2 {
          width: 100vw;
          font-size: calc( #{$heading-lrg--m} - 12px);
          top: calc(-3rem - #{$site-padding--m});
        }
      }
    }
  }
}
</style>
